import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { TransactionRequest } from "shared/models/transaction.model";

export const cardTypeSupportedService = createApi({
  reducerPath: "cardTypeSupportedService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getCardTypeSupportedByMerchant: builder.query<any, {merchant_id: any }>({
      query: (params) => ({
        url: `/card-type-supported/merchant/${params?.merchant_id}`,
        params,
        method: "GET",
      }),
    }),
    saveCardTypeSupportedByMerchant: builder.mutation<any, any>({
      query: (body) => ({
        url: `/card-type-supported/merchant/${body?.merchant_id}`,
        body: body,
        method: "PUT",
      }),
    }),
  }),
});

export const {
  useGetCardTypeSupportedByMerchantQuery,
  useSaveCardTypeSupportedByMerchantMutation
} = cardTypeSupportedService;
